import { I18n } from '@calendly/i18n';
import { BareItem as Item, PopupDropdownMenu } from '@calendly/ui/components/menu';
import { BodyText, HeadingText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { dateNotationSelector, timeNotationSelector } from 'selectors/current_user';
import { buildDateTimeLabel, emphasizeQueryInText } from './utils';
const headerCss = "h1li1zvx";
const Header = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(headerCss, props.className)} />);
const itemContentCss = "i1m0lad";
const ItemContent = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(itemContentCss, props.className)} />);
export const MeetingsDropdown = ({
  meetings,
  searchTerm
}) => {
  const dateNotation = useSelector(dateNotationSelector);
  const timeNotation = useSelector(timeNotationSelector);
  return <PopupDropdownMenu>
      <Header>
        <HeadingText variant="eyebrow">
          {I18n.t('publisher.event_type_editor.sections.available_hours.bookable_events.matching_events_label')}
        </HeadingText>
      </Header>
      {meetings.map(meeting => <Item key={meeting.id}>
          <ItemContent>
            <BodyText>
              {emphasizeQueryInText(meeting.name, searchTerm)}
            </BodyText>
            <BodyText color="muted">
              {buildDateTimeLabel(meeting.startTime, meeting.endTime, dateNotation, timeNotation)}
            </BodyText>
          </ItemContent>
        </Item>)}
    </PopupDropdownMenu>;
};

require("./meetings_dropdown.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meetings_dropdown.js");